import React, { useState, useEffect } from "react";
import "../../Styles/superadmin.css";
import { Doughnut, Bar } from "react-chartjs-2";
import "chart.js/auto";
import { AccountCircle, Group, School, Assignment } from "@mui/icons-material";
import Loader from "../../Components/Loader";

function Home() {
  const [counts, setCounts] = useState({
    totalAdmins: 0,
    totalFaculty: 0,
    totalStudents: 0,
    totalApplications: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchCounts() {
      try {
        const token = localStorage.getItem("authToken");
        if (!token) {
          console.error("No authentication token found");
          return;
        }
        setLoading(true);
        const response = await fetch(
          "https://api.uniums.com/api/dashboard/dashboard-counts",
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const result = await response.json();
        if (result.success) {
          setCounts(result.data);
        }
      } catch (error) {
        console.error("Error fetching dashboard counts:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchCounts();
  }, []);

  const doughnutData = {
    labels: ["Admin", "Faculty", "Student"],
    datasets: [
      {
        data: [counts.totalAdmins, counts.totalFaculty, counts.totalStudents],
        backgroundColor: ["#00bcd4", "#ffc107", "#ff5722"],
        hoverBackgroundColor: ["#00acc1", "#ffb300", "#e64a19"],
      },
    ],
  };

  const barData = {
    labels: ["Admins", "Faculty", "Students"],
    datasets: [
      {
        label: "User Count",
        data: [counts.totalAdmins, counts.totalFaculty, counts.totalStudents],
        backgroundColor: ["#00bcd4", "#ffc107", "#ff5722"],
        borderColor: ["#00acc1", "#ffb300", "#e64a19"],
        borderWidth: 1,
      },
    ],
  };

  const barOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: "top",
      },
    },
  };
  if (loading) {
    return <Loader />;
  }
  return (
    <div className="superadmin">
      <h1 className="dashboard-title">Super Admin Dashboard</h1>
      <div className="dashboard-grid">
        <div className="dashboard-card">
          <AccountCircle className="dashboard-icon big-icon" />
          <h2>Total Admins</h2>
          <p>{counts.totalAdmins}</p>
        </div>
        <div className="dashboard-card">
          <Group className="dashboard-icon big-icon" />
          <h2>Total Faculty</h2>
          <p>{counts.totalFaculty}</p>
        </div>
        <div className="dashboard-card">
          <School className="dashboard-icon big-icon" />
          <h2>Total Students</h2>
          <p>{counts.totalStudents}</p>
        </div>
        <div className="dashboard-card">
          <Assignment className="dashboard-icon big-icon" />
          <h2>New Applications</h2>
          <p>{counts.totalApplications}</p>
        </div>
        <div className="chart-container">
          <h2>Users Distribution</h2>
          <div className="chart-wrapper char_circle">
            <Doughnut data={doughnutData} />
          </div>
        </div>
        <div className="chart-container">
          <h2>User Breakdown</h2>
          <div className="chart-wrapper">
            <Bar data={barData} options={barOptions} />
          </div>
        </div>
        <div className="dashboard-info">
          <h2>Quick Info</h2>
          <ul>
            <li>Admins are responsible for system management.</li>
            <li>Faculty can view and update student progress.</li>
            <li>Students have limited access to HRM features.</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Home;
